import React, {useState, useEffect, useContext} from "react";
import EditablePdf from "../../../../components/forms/EditablePdf";
import {Grid, Col} from "../../../../styles/Grid";
import styled from "styled-components";
import {Input, Label} from "../../../../components/forms/DynamicInput";
import EditableImg from "./EditableImg";
import {AppButton, ResetButton, ButtonWithIcon} from "../../../../styles/Butttons";
import nextId from "react-id-generator";
import {CreateResourceCourse} from "../../../../services/GeneralServices";
import {ReactComponent as PlusIcon} from "../../../../assets/icons/plus.svg";
import {ReactComponent as CancelIcon} from "../../../../assets/icons/cancel.svg";
import AppLoader, {LoadComponet, StatusLoader} from "../../../../components/loaders/Loader";
import {EditCourseContext} from "../../../../context/EditCourseProvider";
import {DeleteResource} from "../../../../services/CoursesServices";
import {useParams} from "react-router-dom";

const MediaCreator = ({idCourse, savePdf, isVisible, continueAction}) => {
   const {mediaCourse, getMediaData} = useContext(EditCourseContext);
   const [isSaving, setSaving] = useState(false);
   const [currentMedia, setmedia] = useState([{idResource: nextId(), data: "", resourceName: ""}]);
   const [onlineMedia, setOnlineMedia] = useState([]);
   let {id} = useParams();

   useEffect(() => {
      if (mediaCourse.data) {
         setOnlineMedia([...mediaCourse.data]);
      }
   }, [mediaCourse]);

   const addMedia = () => {
      // agregar nuevo Item
      setmedia([...currentMedia, {idResource: nextId(), data: "", resourceName: ""}]);
   };

   const sendMedia = (num) => {
      // enviar nuevos itms
      if (currentMedia.length - 1 === num) {
         // console.log("Es el utimo");
         SaveNewResource(currentMedia[num], num);
      } else if (currentMedia.length > num) {
         // console.log("Hay mas");
         SaveNewResource(currentMedia[num], num);
      } else {
         setmedia([]);
         getMediaData(true);
         continueAction();
      }
   };

   const SaveNewResource = (dat, num) => {
      setSaving(true);
      if (dat.data.files) {
         let newData = new FormData();
         newData.append("idCourse", id);
         newData.append("resourceName", dat.resourceName || "Vídeo");
         newData.append("token", localStorage.getItem("domecq_token"));
         newData.append("pathResource", dat.data.files[0]);

         CreateResourceCourse(newData)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               console.log(resp);
               if (status === "error") throw new Error();
            })
            .then(() => {
               setSaving(false);
            })
            .then(() => {
               sendMedia(num + 1);
            })
            .catch((e) => {
               setSaving(false);
               sendMedia(num + 1);
            });
      } else {
         setSaving(false);
         sendMedia(num + 1);
      }
   };

   const setVideoName = (idResource, val) => {
      let newcurent = currentMedia.map((item) => {
         if (item.idResource === idResource) {
            let newiT = {...item, resourceName: val};
            return {...newiT};
         }
         return item;
      });
      setmedia(newcurent);
   };

   const setMedia = (id, file) => {
      let newMediaList = currentMedia.map((item) => {
         if (item.idResource === id) {
            return {...item, data: file.target};
         }
         return item;
      });
      console.log(newMediaList);
      setmedia(newMediaList);
   };

   // video ya públicados
   const deleteVideo = (id) => {
      setSaving(true);
      DeleteResource(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newVideos = onlineMedia.filter((video) => video.idResource !== id);
            setOnlineMedia(newVideos);
         })
         .then(() => setSaving(false))
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   return (
      <>
         <AllGrid>
            <Col large={12} className="sepTop">
               <Label>Videos del curso</Label>

               <Grid>
                  {React.Children.toArray(
                     onlineMedia.map((item) => {
                        return <OnliteItem item={item} deleteVideo={deleteVideo} />;
                     }),
                  )}
               </Grid>

               <Grid>
                  {/* Nuevos recurso */}
                  {mediaCourse.isLoading ? (
                     <LoadComponet />
                  ) : (
                     React.Children.toArray(
                        currentMedia.map((item, index) => {
                           return <MediaItem item={item} index={index} setMedia={setMedia} setName={setVideoName} />;
                        }),
                     )
                  )}
               </Grid>

               <Col large={2} className="sepTop">
                  <ButtonWithIcon Icon={PlusIcon} action={addMedia} text="Agregar vídeo" classname="min" />
               </Col>

               <Grid className="sepTop">
                  <Col large={2} offsetL={10}>
                     <AppButton onClick={() => sendMedia(0)}>Continuar</AppButton>
                  </Col>
               </Grid>
            </Col>
         </AllGrid>
         <StatusLoader isVisible={isSaving} status="Videos" />
      </>
   );
};

export default MediaCreator;

const MediaItem = ({item, index, setMedia, setName, removeItem}) => {
   return (
      <MediaCol large={6} className={`${item.error ? "error" : ""} sepTop`}>
         <Input
            value={item.resourceName}
            placeholder="Nombre del archivo"
            onChange={(e) => {
               setName(item.idResource, e.target.value);
            }}
         />
         <EditableImg
            editable={true}
            change={(e) => setMedia(item.idResource, e)}
            label=""
            name={"media" + index}
            type="video"
            value={item.data}
            fileName=""
         />
      </MediaCol>
   );
};

const OnliteItem = ({item, deleteVideo}) => {
   return (
      <MediaColEdit large={3}>
         <Label>{item.resourceName}</Label>
         <ButtonWithIcon
            action={() => {
               deleteVideo(item.idResource);
            }}
            Icon={CancelIcon}
            classname="min"
            text="Eliminar"
            color="crimson"
            right={true}
         />
      </MediaColEdit>
   );
};

const AllGrid = styled(Grid)`
   .sepTop {
      margin-top: 2em;
   }
`;

const MediaColEdit = styled(Col)`
   display: flex;
   // justify-content: space-between;
   align-items: center;
   padding: 0.5em;
   margin-bottom: 1em;
   box-sizing: border-box;
`;

const MediaCol = styled(Col)`
   display: flex;
   align-items: flex-end;
   margin-top: 0.5em;

   & ${ResetButton} {
      width: auto;
      padding: 0.3em 0.5em;
      height: fit-content;
      color: crimson;
   }

   &.error {
      background: red;
   }

   .row {
      width: 90%;
   }

   &.sepTop {
      margin-top: 1em;
   }
`;

const Title = styled.p``;

const ClasesText = styled.textarea`
   font-size: 1em;
   font-family: Montserrat;
   resize: none;
   width: 100%;
   height: 120px;
   margin: 0.5em 0;
`;
